<template>
  <Modal
    ref="modalRef"
    :show-icon="false"
    :click-to-close="true"
    with-closer
    negative-action-text=""
    positive-action-text="Tamam"
    :modal-style="{ width: '460px' }"
    @on-negative-action-click="close"
    @on-positive-action-click="close"
  >
    <template #body>
      <div
        v-if="campaign"
        class="category-list-modal"
      >
        <h3 class="category-list-modal-title">
          Geçerli Kategori Listesi
        </h3>
        <div
          v-if="campaign?.includedCategories?.length > 0"
          class="category-list-modal-section"
        >
          <div class="category-list-modal-section-title">
            Geçerli Kategoriler:
          </div>
          <div class="category-list-modal-section-text">
            {{
              campaign?.allCategoryIncluded
                ? 'Tüm Kategoriler'
                : categoriesMapping(campaign?.includedCategories)
            }}
          </div>
        </div>

        <div
          v-if="campaign?.excludedCategories?.length > 0"
          class="category-list-modal-section"
        >
          <div class="category-list-modal-section-title">
            Geçerli Olmayan Kategoriler:
          </div>
          <div class="category-list-modal-section-text">
            {{ categoriesMapping(campaign?.excludedCategories) }}
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script setup>
import { ref, defineExpose } from 'vue';
import { Modal } from '@n11/so-ui-components';

const modalRef = ref(null);
const campaign = ref(null);

const open = (campaignData) => {
  campaign.value = campaignData;
  modalRef.value?.openModal?.();
};

const close = () => {
  modalRef.value?.hiddenModal?.();
};

const categoriesMapping = (categories) =>
  (categories ?? []).map((c) => c.name).join(', ');

defineExpose({
  open,
  close,
});
</script>

<style scoped lang="scss">
:deep(.modal-body) {
  margin-top: -26px !important;
}

.category-list-modal {
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow-y: hidden;

  &-title {
    font-size: 20px;
    font-weight: 700;
    letter-spacing: -0.2px;
    line-height: 26px;
    text-align: left;
  }

  &-section {
    letter-spacing: -0.05px;
    line-height: 18px;
    text-align: left;

    &-title {
      font-size: 13px;
      font-weight: 400;
    }

    &-text {
      font-size: 14px;
      font-weight: 600;
    }
  }
}
</style>
